export default function formatDatetime(isoDateTime) {
  const date = new Date(isoDateTime);
  
  // Extract the date components
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = String(date.getFullYear()).slice(0); // Get the last two digits of the year

  // Format the date as "dd/mm/yy"
  const formattedDate = `${day}/${month}/${year}`;

  // Extract the time components
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  // Format the time as "HH:MM:SS"
  const formattedTime = `${hours}:${minutes}:${seconds}`;

  // Combine the formatted date and time
  const formattedDateTime = `${formattedDate} ${formattedTime}`;

  return formattedDateTime;
}

export const formatTimeHMS = (isoDateTime) => {
  const date = new Date(isoDateTime);
  // Extract the time components
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  // Format the time as "HH:MM:SS"
  const formattedTime = `${hours}:${minutes}:${seconds}`;

  const formatTime = `${formattedTime}`;

  return formatTime;
};

export const formatTimeHM = (isoDateTime) => {
  const date = new Date(isoDateTime);
  // Extract the time components
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  // Format the time as "HH:MM"
  const formattedTimeHM = `${hours}:${minutes}`;
  // Combine the formatted date and time
  const formatTimeHM = `${formattedTimeHM}`;

  return formatTimeHM;
};